export const SUBSCRIPTION_RENEW_ANALYSE_MODAL =
  'SUBSCRIPTION_RENEW_ANALYSE_MODAL';
